<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Enter Text</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-input type="textarea" v-model="text" label="Text data" :rows="5"/>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        :disabled="!text"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(text)"
        title="Submit current text"
      >Enter</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from 'mdbvue'

export default {
  name: 'TextAreaModal',
  data () {
    return {
      text: null,
      show: false,
      callback: text => { console.log('Text entered: ', text) }
    }
  },
  methods: {
    close (text = null) {
      this.text = null
      this.show = false
      if (text && typeof text === 'string') {
        this.callback(text)
      }
      this.callback = text => { console.log('Text entered: ', text) }
    }
  },
  mounted () {
    this.$bus.$on('modal-textarea', data => {
      let callback = null
      if (typeof data === 'function') {
        callback = data
      } else if (typeof data === 'object') {
        this.text = data.text || ''
        callback = data.callback
      }
      this.callback = callback
      this.show = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal-textarea')
  },
  components: {
    mdbContainer,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/TextAreaModal.vue